export const transformAddresses = (data: any) => {
    if (!data.addresses || !Array.isArray(data.addresses)) {
        return data;
    }

    const transformedAddresses = data.addresses.map((address: any) => {
        const transformedAddress = { ...address };

        const cityValue = transformedAddress.city;
        const isCityEmpty = !cityValue ||
            (typeof cityValue === 'object' && Object.keys(cityValue).length === 0) ||
            (typeof cityValue === 'object' && !cityValue.id);

        if (isCityEmpty) {
            transformedAddress.city = { id: "" };
        }

        return transformedAddress;
    });

    return {
        ...data,
        addresses: transformedAddresses,
    };
};